import React from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { logout } from "../../store/actions/authAction";
import ApiStatusBadge from "../setting/ApiStatusBadge";
import { ACCOUNT_NAV_ITEMS } from "./accountNavItems";

/*
    Account navigation — ONE component for both layouts.

    Desktop gets a column on the left, mobile gets a strip across the top that
    scrolls sideways when the labels outrun the screen. Which one you see is
    decided entirely by the media queries on .account-nav in account.scss, so
    there is no viewport state in JS, nothing to keep in sync, and no second
    copy of the list to forget to update.

    Logout is the odd one out: it is an action, not a page, so it renders as a
    <button> in the same list and runs the same logout dispatch the header
    dropdown used to.
*/
const AccountNav = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const apiStatus = useSelector((state) => state.apiAccess?.data?.status);

  const handleLogout = () => {
    // Same destination the old header dropdown used.
    dispatch(logout(() => history.push("/api/overview")));
  };

  return (
    <nav className="account-nav" aria-label="Account settings">
      <ul className="account-nav__list">
        {ACCOUNT_NAV_ITEMS.map((item) => (
          <li className="account-nav__item" key={item.key}>
            <NavLink
              to={item.to}
              exact={item.exact}
              className="account-nav__link"
              activeClassName="account-nav__link--active"
            >
              <span>{item.label}</span>
              {item.badge === "apiAccess" && (
                <ApiStatusBadge status={apiStatus || "none"} />
              )}
            </NavLink>
          </li>
        ))}
        <li className="account-nav__item">
          <button
            type="button"
            className="account-nav__link account-nav__button"
            onClick={handleLogout}
          >
            Logout
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default AccountNav;
